import { IAdsBanner } from "../typings/IAdsBanner";
import http from "./client";


export interface IBannersSortParams {
  sortBy: 'views' | 'clicks' | 'ctr' | 'created';
  order: 'asc' | 'desc';
}
export interface IBannerListQueryParams extends IBannersSortParams {
  course_id: string | number;
  search?: string;


}

async function list(params: IBannerListQueryParams) {
  /**
   * sortable fields: views, clicks, ctr, created
   */
  const response = await http.get('/api/promo/list', {
    params
  });

  return response.data;
}

async function byId(adId: string | number, courseId: string | number) {
  const response = await http.get('/api/promo/by-id', {
    params: {
      id: adId,
      course_id: courseId
    }
  });
  return response.data;
}

async function remove(adId: string | number, courseId: string | number) {
  http.post('/api/promo/delete', {
    id: adId,
    course_id: courseId
  });
}
async function create(banner: Partial<IAdsBanner>, courseId: string | number) {
  const response = await http.post('/api/promo/save', banner, {
    params: {
      course_id: courseId,
    }
  });

  return response.data;
}
async function update(banner: IAdsBanner, courseId: string | number) {
  await http.post('/api/promo/save', banner, {
    params: {
      course_id: courseId,
    }
  });
}

async function updateStatus(courseId: string | number, adId: number, status: IAdsBanner['status']) {
  await http.post('/api/promo/status', {
    id: adId,
    status: status,
  }, {params: {course_id: courseId}})
}

const banners = {
  list, byId, create, update, remove, updateStatus
};

export default banners;